module.exports = __webpack_public_path__ + "img/mk_get.ceaeee7.png";